import * as o from "react";
import e from "../lib/IconBase.es.js";
import m from "../defs/Star.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...t, weights: m }));
r.displayName = "StarIcon";
const n = r;
export {
  n as Star,
  r as StarIcon
};
